var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrintMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10808",
    "data-name": "Grupo 10808",
    transform: "translate(1472 -280)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-print",
    "data-name": "Icon awesome-print",
    d: "M16.042,6.875V2.766a1.146,1.146,0,0,0-.336-.81L14.086.336A1.146,1.146,0,0,0,13.275,0H3.438A1.146,1.146,0,0,0,2.292,1.146V6.875A2.291,2.291,0,0,0,0,9.167v4.01a.573.573,0,0,0,.573.573H2.292v3.438a1.146,1.146,0,0,0,1.146,1.146H14.9a1.146,1.146,0,0,0,1.146-1.146V13.75H17.76a.573.573,0,0,0,.573-.573V9.167A2.291,2.291,0,0,0,16.042,6.875ZM13.75,16.042H4.583V12.6H13.75Zm0-8.021H4.583V2.292h6.875V4.01a.573.573,0,0,0,.573.573H13.75ZM15.469,10.6a.859.859,0,1,1,.859-.859A.86.86,0,0,1,15.469,10.6Z",
    transform: "translate(-1466.167 285.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17740",
    "data-name": "Rect\\xE1ngulo 17740",
    width: 30,
    height: 30,
    transform: "translate(-1472 280)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintMenu);
export default __webpack_public_path__ + "static/media/print-menu.1285d71fe81e08bcfb87f17568db7213.svg";
export { ForwardRef as ReactComponent };